import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const headingWrapper = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-400);
  ${breakpoints.to.tablet} {
    gap: var(--space-200);
  }
`;

export const warningMessageWrapper = css`
  ${breakpoints.from.desktop} {
    width: 408px;
  }
`;
